import { schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../../api/fetch';

export function getCheckout() {
  return fetch(
    '/payment/stripe/checkout',
    { method: 'GET' },
    schemas.CheckoutSession
  );
}

export function useCheckout() {
  return useQuery({
    queryKey: ['checkout'],
    queryFn: () => getCheckout(),
    retry: false
  });
}
